import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { SHELL_LOGIN_URL } from '../../core/shell/shell-routes.constant';
import { SUBSCRIPTION_URLS } from '../constants/subscription-routes.constant';
import { SubscriptionExitService } from '../services/subscription-exit.service';

const EXITS_WITHOUT_CONFIRMATION = [
  SUBSCRIPTION_URLS.success,
  SUBSCRIPTION_URLS.failed,
  SUBSCRIPTION_URLS.serviceError,
  SHELL_LOGIN_URL,
];

export const exitGuard: CanDeactivateFn<unknown> = (
  _component,
  _currentRoute,
  _currentState,
  nextState
) => {
  const nextUrl = nextState?.url ?? '';

  if (EXITS_WITHOUT_CONFIRMATION.some((url) => nextUrl.startsWith(url))) {
    return true;
  }

  return inject(SubscriptionExitService).confirmExit();
};
